import React from 'react';

const PlaybookCard = ({ children, className = '' }) => (
  <section
    className={`bg-gray-900/80 border border-gray-800 rounded-xl shadow-lg shadow-black/10 p-6 mb-2 transition hover:shadow-xl focus-within:shadow-xl dark:bg-gray-900/90 dark:border-gray-700 ${className}`}
    tabIndex={0}
  >
    {children}
  </section>
);

export default PlaybookCard; 